export default __webpack_public_path__ + "static/media/fl3.095330d1.png";